import { qs, qsa } from './utils.js'
import { resetVeteranUpload } from './uploader.js';
import { updateRatesView } from './prices.js';

export function initPatientBlocks (container, {
    returnBlockSelector, newBlockSelector, hiddenClass, errorClass
}) {
    const returnBlock = qs(container, returnBlockSelector);
    const newBlock = qs(container, newBlockSelector);
    const returnInput = returnBlock ? returnBlock.querySelector('input') : null;

    newBlock?.classList.add(hiddenClass);

    if (returnInput) {
        returnInput.addEventListener('input', () => {
            if (returnInput.value.trim()) returnInput.classList.remove(errorClass);
        });
    }

    return { returnBlock, newBlock, returnInput };
}

export function syncPatientDependentBlocks (container, {
    patientDropdownId, returningValue, newValue, newBlockSelector, returnBlockSelector, hiddenClass, errorClass
}) {
    const dd = qs(container, patientDropdownId);
    const val = dd ? (dd.dataset.value || '') : '';

    const returnBlock = qs(container, returnBlockSelector);
    const newBlock = qs(container, newBlockSelector);
    const returnInput = returnBlock ? returnBlock.querySelector('input') : null;

    if (newBlock) newBlock.classList.toggle(hiddenClass, val !== newValue);

    if (returnBlock) {
        const showReturn = val === returningValue;
        returnBlock.classList.toggle(hiddenClass, !showReturn);
        const veteranCheck = qs(container, '#veteranCheck');
        // unset veteran check if switching away from returning patient
        if (showReturn && veteranCheck) {
            veteranCheck.checked = false;
            veteranCheck.dispatchEvent(new Event('change'));
        }
        if (!showReturn && returnInput) returnInput.classList.remove(errorClass);
    }

    if (val === returningValue) {
        resetVeteranUpload(container, { errorClass, hiddenClass });
    }

    qsa(container, '.book__chooseCalendarHead').forEach(head => {
        head.classList.toggle(hiddenClass, (head.getAttribute('data-head') || '') !== val);
    });

    //updateRatesView(container);
}